import { Pipe, PipeTransform } from '@angular/core';
import { ProcessStatusDetail } from '@rds/rds-base-ts';
import { instanceOfPackagingProcessStatusDetail } from '@rds/rds-packaging-ts';

@Pipe({
  name: 'getI18nDownloadLabel',
})
export class GetI18nProcessManagerDownloadeLabelPipe implements PipeTransform {
  transform(detail: ProcessStatusDetail): string {
    const resource = instanceOfPackagingProcessStatusDetail(detail) ? detail.resourceName : detail.id;
    return $localize`Download ${resource}:label:`;
  }
}
